var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            key: "pn",
            attrs: { prop: "paramName", label: "参数", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.paramName) + " "),
                    scope.row.paramDesc
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: scope.row.paramDesc,
                              placement: "top",
                              "popper-class": "prod__record",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-info",
                              staticStyle: {
                                "margin-left": "2px",
                                color: "#f8ab01",
                                "font-size": "10px",
                                cursor: "pointer",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.columns, function (column, index) {
            return _c("el-table-column", {
              key: index,
              attrs: { label: column.columnName, "min-width": "120" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(column.columnName) + " "),
                        column.columnDesc
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  effect: "dark",
                                  content: column.columnDesc,
                                  placement: "top",
                                  "popper-class": "prod__record",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-info",
                                  staticStyle: {
                                    "margin-left": "2px",
                                    color: "#f8ab01",
                                    "font-size": "10px",
                                    cursor: "pointer",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }